import { DataDRequest } from "../../data/DRequest";
import { _ModalConfirmacion, IModalConfirmacionConfig } from "./ModalThings/ModalConfirmacion";
import { _ModalConfirmacionBasico } from "./ModalThings/ModalConfirmacionBasico";
import { _ModalConfirmacionBasicoV2, IModalConfirmacionBasicoV2Config } from "./ModalThings/ModalConfirmacionBasicoV2";
import { _ModalForm, IModalFormConfig } from "./ModalThings/ModalForm";
import { _ModalInfoDataList, IModalInfoDataListConfig } from "./ModalThings/ModalInfoDataList";
import { _ModalServiceIterator, IModalServiceIteratorConfig } from "./ModalThings/ModalServiceIterator";
import { _ModalServiceIteratorAdvance, IModalServiceIteratorAdvanceConfig } from "./ModalThings/ModalServiceIteratorAdvance";
import { _ModalServiceIteratorBasic, IModalServiceIteratorBasicConfig } from "./ModalThings/ModalServiceIteratorBasic";
import { _ModalSimple } from "./ModalThings/ModalSimple";
import { _ModalToALongProccess } from "./ModalThings/ModalToALongProccess";
import { _ModalToAProccess, IModalToAProccessConfig } from "./ModalThings/ModalToAProccess";
import { ModalThingsUtil as util } from "./ModalThings/Utils";

import IModalThings = util.IModalThings

type IResponseItemData<Data> = util.IResponseItemData<Data>

/** @deprecated
 *
 * Usar ./ModalThings/*
 */
export namespace ModalThings {


    type IModalThingsBase1 = util.IModalThingsBase1
    /** @deprecated */
    export interface IConfigProcessServiceByServiceAdvance<TData> extends IModalServiceIteratorAdvanceConfig<TData> { }
    /** @deprecated
     * Usar {{@link _ModalServiceIteratorAdvance}} en su lugar
     */
    export async function _OpenModalToProccessServiceByServiceFromAArrayAdvance<TData>(config: IConfigProcessServiceByServiceAdvance<TData>): Promise<IResponseItemData<TData>[] | null> {
        return _ModalServiceIteratorAdvance(config)
    }



    /** Modal sin pie 🦶 */
    export function _GetModalSimple(config: Pick<IConfigModalConfirmacion, "DrawContent" | "Message" | "StrModalBotons" | "Title" | "Width" | "LangModuleKeyInContext">) {
        return _ModalSimple(config)
    }



    /**
     * @param title titulo de modal @default "Mensaje de confirmación"
     * @param content acepta html, si es `string` se appendiza dentro de un elemento `<label>`
     * @param width @default 400 + "px"
     * @param typeStrModalBotons @default "aceptar_cancelar"
     *
     * // NOTE No tiene soporte para ajustar Lang context
     * @deprecated
     * Usar {{@link _ModalConfirmacionBasico}} en su lugar
     */
    export function _GetConfirmacionBasico(title: (string | null), content: string | TSelectionHTML<"htmlelement"> | HTMLElement, width = 400, typeStrModalBotons: util.TStrToModalBotons = "aceptar_cancelar") {
        return _ModalConfirmacionBasico(title, content, width, typeStrModalBotons);
    }



    /** @deprecated */
    interface IConfigModalConfirmacion extends IModalConfirmacionConfig { }
    /** Si no se define OnAccept, el botón de "Cancelar" | "No" no será visible
     * * Retorna null, si no se tiene permisos
     *
     * @deprecated
     *
     * Usa {{@link _ModalConfirmacion}} en su lugar
     */
    export function _GetConfirmacionModal(conf: IConfigModalConfirmacion): (IModalThings | null) {
        return _ModalConfirmacion(conf)
    }



    /** @deprecated */
    interface IConfigModalConfirmacionBasicoV2 extends IModalConfirmacionBasicoV2Config { }
    /** // NOTE No tiene soporte para ajustar Lang context
     * @deprecated
     * Usar {{@link _ModalConfirmacionBasicoV2}} en su lugar
    */
    export function _GetConfirmacionBasicoV2(config: IConfigModalConfirmacionBasicoV2) {
        return _ModalConfirmacionBasicoV2(config)
    }



    /** @deprecated */
    export interface IConfigModalToForm<T, TExtras = any> extends IModalFormConfig<T, TExtras> { }
    /** Modal especial para un proceso de Formulario
     * @deprecated
     *
     * Usar {{@link _ModalForm}} en su lugar
    */
    export function _GetModalToForm<T, TExtras = any>(config: IConfigModalToForm<T, TExtras>) {
        return _ModalForm(config)
    }



    /** @deprecated */
    export interface IConfigModalToAProccess<TExtras> extends IModalToAProccessConfig<TExtras> { }
    /** Modal especial para un proceso X
     * @deprecated
     *
     * Usar {{@link _ModalToAProccess}} en su lugar
    */
    export function _GetModalToAProccess<TExtras = any>(config: IConfigModalToAProccess<TExtras>) {
        return _ModalToAProccess(config)
    }



    /** @deprecated */
    interface IConfigModalInfoData<TData> extends IModalInfoDataListConfig<TData> { }
    /**
     * Muestra una lista de elementos X a manera de resumen básico
     *
     * * Por defecto solo muestra el boton de "Aceptar" (BtnRight)
     * @param config
     *
     * @deprecated
     *
     * Usar {{@link _ModalInfoDataList}} en su lugar
     */
    export function _GetModalInfoDataList<TData>(config: IConfigModalInfoData<TData>) {
        return _ModalInfoDataList(config)
    }



    /** @deprecated */
    export interface IConfigProcessServiceByServiceBasic<TData> extends IModalServiceIteratorBasicConfig<TData> { }
    /** * Verifica permisos antes de abrir el modal, en caso de no tener permisos, no abre el modal, se necesita: Action, Modulo, IdsEscuelas (Opcional)
     * * Al finalizar, verifica si existen items incorrectos y muestra un modal a modo de resumen,
     * * La promesa devuelve (en caso de tener permisos) la lista de todos los datos a procesar con sus respectivos resultados de proceso.
     * @deprecated
     * Usar {{@link _ModalServiceIteratorBasic}} en su lugar
    */
    export async function _OpenModalToProccessServiceByServiceFromAArrayBasic<TData>(config: IConfigProcessServiceByServiceBasic<TData>): Promise<IResponseItemData<TData>[] | null> {
        return _ModalServiceIteratorBasic(config)
    }



    interface IConfigProcessServiceByServiceIterator<T> extends IModalServiceIteratorConfig<T> { }
    /** Proceso de iteración de datos recursivo
     *
     * Finaliza cuando:
     * * Todos los datos se procesan correctamente (res.Resultado > 0)
     * * N datos resultan erroneos y no se Reintenta procesarlos
     *
     * dataProcess:
     * * Al finalizar en implementación se puede ver dataProcess modificado
     *
     * @deprecated
     *
     * Usar {{@link _ModalServiceIterator}} en su lugar
     */
    export function _ProccessServiceByServiceFromAArrayIterator<TData>(modalThings: IModalThings, dataProccess: IResponseItemData<TData>[], config: IConfigProcessServiceByServiceIterator<TData>, showNotif = true) {
        return _ModalServiceIterator(modalThings, dataProccess, config, showNotif)
    }



    // ****************************************************************
    // DOTEST MODAL TO A LONG PROCCESS // DOTEST
    // ****************************************************************

    /** @deprecated */
    interface IModalThings_LongProccess extends IModalThings {
        Next();
        Previus();
        CancelAndClose();
        // FocusItem(id: string): boolean;
        GetCurrentStepId(): string;
        // GetCurrentStep(): string;
    }
    /** @deprecated */
    type TModalToALongProccessItem_ValidationResult = (boolean | { IsValid: boolean, Message?: string });
    /** @deprecated */
    export interface IConfigModalToALongProccessItem {
        Id: string;
        Title: string;
        /** Personaliza contenido extra despues del mensaje de confirmación */
        OnDrawContent: (content: TSelectionHTML<"div">, modalThings: IModalThings) => void;
        OnFocusContent?: (content: TSelectionHTML<"div">, modalThings: IModalThings_LongProccess) => void;
        /** @default 500 px */
        Width?: number;
        Height?: string;
        NextID?: (string | ((modalThings: IModalThings_LongProccess) => string));
        PreviousID?: (string | ((modalThings: IModalThings_LongProccess) => string));
        /** Valida current step para evaluar si se puede enfocar el elemento siguiete */
        OnValideStep?: (content: TSelectionHTML<"div">, modalThings: IModalThings_LongProccess) => TModalToALongProccessItem_ValidationResult | Promise<TModalToALongProccessItem_ValidationResult>;

        OnAccept?: (modalThings: IModalThings) => Promise<DataDRequest.IRequestResponseA<any>>;
    }
    // type TConfigModalToALongProccessSteps = { [key: string]: IConfigModalToALongProccessItem<any> };
    // type TConfigModalToALongProccessSteps<T> = {
    //     [k in keyof T]: IConfigModalToALongProccessItem<keyof T & string>;
    // }[keyof T]

    /** @deprecated */
    interface IConfigModalToALongProccess extends Pick<IModalThingsBase1, "Modulo" | "Action" | "IdsEscuelas" | "LangModuleKeyInContext"> {
        /** Si se define "Action", por default toma la cadena del key del enum, a menos que se defina */
        AccionToHttpMessage?: string;

        StepsConfig: IConfigModalToALongProccessItem[];
        //SetConfig: <TStepsConfig extends TConfigModalToALongProccessSteps<TStepsConfig>>() => TStepsConfig2;
        StartEndIds: [string, string];
        OnClose?: () => void;
    }

    // type TConfigModalToALongProccessKeys = keyof TConfigModalToALongProccessSteps<undefined>;

    /**
     * Modal especial para un proceso X de varios pasos
     *
     * @deprecated
     * Usar {{@link _ModalToALongProccess}} en su lugar
    */
    export function _GetModalToALongProccess(config: IConfigModalToALongProccess) {
        return _ModalToALongProccess(config)
    }
}